import React from 'react';
import Admin from 'hive-admin';
import { ADMIN as FILTERS_ADMIN, SELLER as FILTERS_SELLER } from './filters';
import { ADMIN as COLUMNS_ADMIN } from './columns';
import { ADMIN as FIELDS_ADMIN, SELLER as FIELDS_SELLER } from './fields';

import { getI18nFields } from '../../helpers/i18n';

export default [
  ['ADMIN', {
    path: '/billing-invoicing/adjustments',
  }],
//   ['SELLER', {
//     path: '/store/warehouses',
//     archiveLoadUrl: '/warehouses',
//   }],
].reduce(
  (pages, [forRole, config]) => {
    const [
      COLUMNS,
      FILTERS,
      FIELDS,
    ] = (
      [COLUMNS_ADMIN, FILTERS_ADMIN, FIELDS_ADMIN]
    );
    pages.push(...Admin.compileFromLibrary(['GroupResource', {
      title: 'Adjustments',
      // icon: 'ordered-list',
      archiveConfig: {
        title: 'Adjustments',
        label: 'Adjustments',
        // icon: 'ordered-list',
        hidden: [
          [
            'condition.checkViewer',
            'role', '!==', forRole,
          ],
        ],
        createButtonPath: `${config.path}/create`,
      },
      singleLoadUrl: `/warehouses/:id/?${
        [
          'store=true',
        ].join('&')
      }`,
    //   singleCreateConfig: {
    //     headerTitle: 'New Warehouse',
    //   },
      singleConfig: {
        hidden: true,
        alias: config.path,
        backButtonPaths: [config.path],
        getPageFields: getI18nFields,
        renderHeaderTitle: (props) => (
           props.data?.name
            ? (
                <span style={{ textTransform: 'capitalize' }}>
                  {props.data.name || 'N/A'}
                </span>
              )
            : 'Warehouse'
    ),
      },
      singleEditConfig: {
        actions: [
          ['ActionSave', {
            handleSuccess: (data, props) => props.reload(),
          }],
        //  ['ActionDelete'],
        ],
      },
      redirect: [
        ['redirect.unauthorized'],
        [
          'redirect.checkViewer',
          'role', '!==', forRole,
            forRole === 'ADMIN'
          ? '/store/warehouses'
          : forRole === 'SELLER'
          ? '/warehouses'
          : null,
        ],
      ],
      columns: COLUMNS,
      // filters: FILTERS,
      fields: FIELDS,
      ...config,
    }]).pages);
    return pages;
  },
  [],
);
